import { ConcreteEncodable } from "./ConcreteEncodable";

import { ApplicationNotificationFetchDescriptorImplEncoder } from "../../encoder/ApplicationNotificationFetchDescriptorImplEncoder";

import * as CubiqTS from "../../index";
import { ApplicationNotificationFetchDescriptor } from "../ApplicationNotificationFetchDescriptor";

export class ApplicationNotificationFetchDescriptorImpl
  extends ConcreteEncodable
  implements ApplicationNotificationFetchDescriptor
{
  public static enType: string = "com.bcdfx.model.event.ApplicationNotificationFetchDescriptorImpl";

  /*FID=1*/
  public eventType: CubiqTS.ApplicationNotificationEventType;
  /*FID=2*/
  public filterName: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = ApplicationNotificationFetchDescriptorImplEncoder.Instance;
    this.setEncodableType(ApplicationNotificationFetchDescriptorImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "ApplicationNotificationFetchDescriptorImpl[" +
      "eventType=" +
      this.eventType +
      "filterName=" +
      this.filterName +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
